import b2bCartHelpers from 'Assets/js/components/b2bCartHelpers';

const actions = {
  async addB2bGroup(context, payload) {
    const { name, contacts } = payload;

    const groupsJson = context.state.b2b.groups;
    const groups = JSON.parse(groupsJson);
    const id = groups.groups.length + 1;

    groups.groups.push({ id, name, contacts });
    const newGroupsJSON = JSON.stringify(groups);
    context.commit('setB2bGroups', newGroupsJSON);

    const b2bHelper = b2bCartHelpers.getInstance();
    // eslint-disable-next-line no-undef
    await b2bHelper.updateShopifyB2bGroup(id, name, () => {
      // eslint-disable-next-line no-console
      // console.log('response:', response);
    });
  },
  async updateShopifyGroup(context, payload) {
    const { id, updatedName, updatedContacts } = payload;

    const groupsJson = context.state.b2b.groups;
    const groups = JSON.parse(groupsJson);

    // eslint-disable-next-line no-restricted-syntax
    for (const group of groups.groups) {
      if (group.id === id) {
        group.name = updatedName;
        group.contacts = updatedContacts;
      }
    }

    const newGroupsJSON = JSON.stringify(groups);
    context.commit('setB2bGroups', newGroupsJSON);

    const b2bHelper = b2bCartHelpers.getInstance();
    await b2bHelper.updateShopifyB2bGroup(newGroupsJSON, () => {
      // eslint-disable-next-line no-console
      // console.log('response: ', response);
    });
  },
  async deleteB2bGroup(context, payload) {
    // eslint-disable-next-line no-console
    const id = payload;
    const groupsJson = context.state.b2b.groups;
    const groups = JSON.parse(groupsJson);

    const groupIndex = groups.groups.findIndex((group) => group.id === payload);

    if (groupIndex !== -1) {
      groups.groups.splice(groupIndex, 1);
      const newGroupsJSON = JSON.stringify(groups);
      context.commit('setB2bGroups', newGroupsJSON);

      const b2bHelper = b2bCartHelpers.getInstance();
      await b2bHelper.updateShopifyB2bGroup(id, () => {
        // eslint-disable-next-line no-console
        // console.log('response:', response);
      });
    } else {
      // eslint-disable-next-line no-console
      // console.log(`Group with ID ${id} not found.`);
    }
  }
};

export default actions;
